module.exports = __webpack_public_path__ + "img/plus-green.9520dde1.svg";